import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { HrMaxPrice } from '~/Api/User/ProductGroup/HrMaxPrice/HrMaxPrice';
import { selectComparativeDataSources } from '~/HrMaxPrice/reducer';
import { formatPercentage } from '~/utils/Intl';

import Calculation from './Calculation';

const memoizedSelectComparativeDataSources = memoizeOne(selectComparativeDataSources);

interface OwnProps {
	hrMaxPrice: HrMaxPrice;
}

const mapStateToProps = (_: Record<never, never>, props: OwnProps) => {
	const { hrMaxPrice } = props;
	return {
		dataSources: memoizedSelectComparativeDataSources(hrMaxPrice),
		formatPercentage,
	};
};

export default connect(mapStateToProps)(Calculation);
